<template>
    <div class="date-chooser-wrapper">
        <div class="date-chooser" role="dialog">
            <section class="header">
                <h3>
                    Select your dates for {{ house.name }}
                </h3>
                <template v-if="days.length">
                    <div class="dates">
                        Check in: <span v-html="dateInFormatted" />
                        <br>
                        Check out: <span v-html="dateOutFormatted" />
                        <br>
                        Rent: {{ rent ? ('$ ' + rent.toFixed(2)) : '' }}
                        <span v-if="hasDiscount" style="font-size: 70%; font-style: italic;"> (includes discount)</span>
                        <!--
                                            <br>
                                            <span style="font-size: 10pt;">(Discounts and tax applied later.)</span>
                        -->
                    </div>

                    <div class="controls">
                        <button
                            v-text="'Cancel'"
                            @click="$emit('cancel')"
                        />
                        <button
                            v-text="'Book these dates'"
                            @click="$emit('done', stayDays)"
                            :disabled="!(myDateIn && myDateOut)"
                        />
                    </div>

                    <div class="month-jump">
                        <label v-text="'Jump to:'" />
                        <select
                            v-model="firstMonthVisible"
                            @change="goMonth(firstMonthVisible)"
                        >
                            <option
                                v-for="month in jumpMonths"
                                :key="month.ym"
                                :value="month.ym"
                                v-text="month.formatted"
                            />
                        </select>

                    </div>
                </template>
            </section>

            <section class="months">
                <template v-if="days.length">

<!--
                    <div class="month-prev">
                        <i
                            v-if="!loadingPrevMonth"
                            class="fas fa-angle-double-up"
                            @click="goMonthPrev"
                            :class="{hidden: earliestMonthToShow === firstMonthVisible}"
                        />
                        <i v-else class="fas fa-spinner fa-spin" />
                    </div>
-->

                    <month-grid
                        v-for="monthProp in monthPropsToShow"
                        :key="monthProp"
                        :days="months[monthProp]"
                        :month="monthProp"
                        :mode="mode"
                        :date-in="myDateIn"
                        :date-out="myDateOut"
                        :hover-date="hoverDate"
                        :hover-day="hoverDay"
                        :show-prev-month-button="monthProp === firstMonthVisible && earliestMonthToShow !== firstMonthVisible"
                        :show-next-month-button="monthProp === lastMonthVisible && mayLoadNextMonth"
                        @go-prev-month="goMonthPrev"
                        @go-next-month="goMonthNext"
                        @check-in="setCheckIn"
                        @check-out="setCheckOut"
                        @hover="hoverDate = $event"
                    />
    <!--                :ref="monthProp.replace('-', '_')"-->

<!--
                    <div class="month-next">
                        <i
                            v-if="mayLoadNextMonth"
                            class="fas fa-angle-double-down"
                            @click="goMonthNext"
                        />
                        <i v-else-if="loadingNextMonth" class="fas fa-spinner fa-spin" />
                    </div>
-->

                </template>
            </section>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

import minMax from 'dayjs/plugin/minMax';
import groupby from 'lodash.groupby';
// import { validationMixin } from 'vuelidate';
// import { required, requiredIf, integer, email, minValue, between } from 'vuelidate/lib/validators';
// import * as calcs from '../../../_modules/reservationCalcs';

import MonthGrid from './MonthGrid.vue';

import { getDaysForMonth } from '../_modules/getDaysForMonth';
// import axios from 'axios';
// import swal from 'sweetalert';
// import ReservationRequest from '../../blocksJUNK/_components/ReservationRequest/ReservationRequest.vue';
// import ReservationRequestAgreements from './ReservationRequest/ReservationRequest-Agreements.vue';
// import ReservationRequestConfirm from './ReservationRequest/ReservationRequest-Confirm.vue';
// import ReservationRequestGuest from './ReservationRequest/ReservationRequest-Guest.vue';
// import ReservationRequestPayment from './ReservationRequest/ReservationRequest-Payment.vue';

// const truthy = (value) => !! value;
// const agreedIfRequired = (agreement) => {
//     return !agreement.required || agreement.agreed;
// }

import * as calcs from '../../../_modules/reservationCalcs';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(minMax);

// const taxRate = 0.09;
export default {
    components: {
        MonthGrid,
    },

    props: {
        house: {
            type: Object,
        },
        
        dateIn: {
            type: String,
        },

        dateOut: {
            type: String,
        },

        // rent: {
        //     type: Number,
        // },

        // days: {
        //     type: Array,
        //     default: () => [],
        // },
    },

    data() {
        return {
            days: [],

            myDateIn: this.dateIn,
            myDateOut: this.dateOut,

            firstMonthVisible: null,
            nMonthsVisible: 2,
            loadingPrevMonth: false,
            loadingNextMonth: false,
            hoverDate: null,

            myEarliestMonthToShow: null,
        };
    },

    computed: {
        mode() {
            if (this.myDateIn && this.myDateOut) {
                return 'selected';
            } else {
                return this.myDateIn ? 'check-out' : 'check-in';
            }
        },

        earliestMonthToShow() {
            return this.myEarliestMonthToShow ?? dayjs().format('YYYY-MM');
        },

        mayLoadNextMonth() {
            return !this.loadingNextMonth
                && this.lastMonthVisible < this.house.config.latestMonthToShow.substring(0, 7)
            ;
        },

        months() {
            return groupby(this.days, day => dayjs(day.date).format('YYYY-MM'));
        },

        monthProps() {
            return Object.keys(this.months).sort();
        },

        monthPropsToShow() {
            if (this.monthProps.length <= this.nMonthsVisible) {
                return [];
            }
            return this.monthProps
                .slice(this.iFirstMonthVisible, this.iFirstMonthVisible + this.nMonthsVisible);
        },

        iFirstMonthVisible() {
            return this.monthProps.indexOf(this.firstMonthVisible);
        },

        lastMonthVisible() {
            return this.monthProps[this.iFirstMonthVisible + this.nMonthsVisible - 1];
        },

        hoverDay() {
            return this.days.find(day => day.date === this.hoverDate);
        },

        jumpMonths() {
            // return [...Array(12).keys()]
            //     .map(i => {
            //         let month = dayjs().add(i, 'month').startOf('month');
            //         return {
            //             ym: month.format('YYYY-MM'),
            //             formatted: month.format('MMMM YYYY'),
            //         };
            //     })
            // ;
            console.debug('earliestMonthToShow', this.earliestMonthToShow);
            console.debug('latestMonthToShow', this.house.config.latestMonthToShow);
            let month = dayjs(this.earliestMonthToShow + '-01');
            let lastMonth = dayjs(this.house.config.latestMonthToShow);
            let months = [];
            while (month.isSameOrBefore(lastMonth)) {
                months.push({
                    ym: month.format('YYYY-MM'),
                    formatted: month.format('MMMM YYYY'),
                });
                month = month.add(1, 'month');
            }
            return months;
        },

        stayDays() {
            return this.days.filter(day => day.date >= this.myDateIn && day.date < this.myDateOut)
                .sort((a, b) => a.date > b.date ? 1 : -1)
            ;
        },

        hasDiscount() {
            return !!calcs.discount(this.stayDays);
        },

        rent() {
            return calcs.subtotal(this.stayDays);
        },

        dateInFormatted() {
            return this.myDateIn ? dayjs(this.myDateIn).format('MMM D, YYYY') : '<i>Click date below</i>';
        },

        dateOutFormatted() {
            return this.myDateOut
                ? dayjs(this.myDateOut).format('MMM D, YYYY')
                : this.myDateIn
                    ? '<i>Click date below</i>'
                    : ''
            ;
        },
    },

    methods: {
        getDaysForMonth,

        loadDaysForMonth(month) {
            return this.getDaysForMonth(month, this.house.slug)
                .then(days => {
                    if (month === null) {
                        this.myEarliestMonthToShow = dayjs(days[0].date).format('YYYY-MM');
                    }
                    month = month || days[0].date.substring(0, 7);
                    let daysInMonth = [];
                    for (let i = 1; i <= dayjs(month + '-01').daysInMonth(); i++) {
                        const day = ('0' + i).substring(('0' + i).length - 2);
                        daysInMonth.push(month + '-' + day);
                    }

                    daysInMonth.forEach(dayInMonth => {
                        if (!days.find(day => day.date === dayInMonth)) {
                            days.push({
                                date: dayInMonth,
                                open: false,
                                // is_blocked_original: true,
                                is_blocked: true,
                                may_check_in: false,
                                may_check_out: false,
                                min_days: 0,
                                fits_a_block: false,
                                check_out_blocked: false,
                            });
                        }
                    })

                    // this.days.push(...days);

                    // this.days.push(...days.map(day => {
                    //     day.is_blocked_original = day.is_blocked;
                    //     return day;
                    // }));

                    this.days.push(...days.map(day => {
                        day.open = day.open && dayjs(day.date).isSameOrAfter(dayjs().add(2, 'days'), 'day');
                        return day;
                    }));

                    return this.mungeDays();

                })
                .catch(error => {
                    console.error(error);
                })
            ;
        },

        mungeDays() {
            this.days.sort((a, b) => a.date > b.date ? 1 : -1);

            this.days.forEach((day, iDay) => {
                // look forward to see if min_days can be met
                let minDaysAvailable = true;
                for (let i = 1; i <= day.min_days && i < this.days.length; i++) {
                    let futureDay = this.days[iDay + i];
                    if (!(futureDay && futureDay.open && !futureDay.is_blocked)) {
                        minDaysAvailable = false;
                        break;
                    }
                }
                if (minDaysAvailable) {
                    let testedDay = this.days[iDay];
                    while (testedDay && testedDay.open && !testedDay.is_blocked) {
                        testedDay.fits_a_block = true;
                        iDay++;
                        testedDay = this.days[iDay];
                    }
                    // return;
                }
            })
        },

        setCheckIn(date) {
            this.myDateOut = null;
            this.myDateIn = date;
            const dayIn = this.days.find(day => day.date === date);
            let interveningBlock = false;
            this.days.forEach((day) => {
                day.check_out_blocked = false;
                if (day.date <= this.myDateIn) {
                    day.check_out_blocked = true;
                    return;
                }
                if (interveningBlock) {
                    day.check_out_blocked = true;
                    return;
                }

                if (day.is_blocked || !day.open) {
                    interveningBlock = true;
                    day.check_out_blocked = true;
                    return;
                }

                if (!day.may_check_out) {
                    day.check_out_blocked = true;
                    return;
                }

                if (dayjs(day.date).diff(this.myDateIn, 'day') < dayIn.min_days) {
                    day.check_out_blocked = true;
                    return;
                }
            })
        },

        setCheckOut(date) {
            this.myDateOut = date;
        },

        goMonthPrev() {
            if (this.loadingPrevMonth || (this.firstMonthVisible === this.earliestMonthToShow)) {
                return;
            }

            this.loadingPrevMonth = true;
            let prevMonth = dayjs(this.firstMonthVisible).subtract(1, 'month').format('YYYY-MM');
            this.goMonth(prevMonth)
                .then(() => {
                    this.loadingPrevMonth = false;
                })
            ;
        },

        goMonthNext() {
            if (this.loadingNextMonth) {
                return;
            }
            if (this.lastMonthVisible >= this.house.config.latestMonthToShow) {
                return;
            }

            this.loadingNextMonth = true;
            this.goMonth(this.lastMonthVisible)
                .then(() => {
                    this.loadingNextMonth = false;
                })
            ;
        },

        goMonth(month) {
            let promises = [];
            if (month === this.house.config.latestMonthToShow) {
                month = dayjs(month + '-01').subtract(1, 'month').format('YYYY-MM');
            }
            let monthToLoad = month;
            for (let i = 0; i < 2; i++) {
                if (this.monthProps.includes(monthToLoad)) {
                    promises.push(Promise.resolve());
                } else {
                    promises.push(this.loadDaysForMonth(monthToLoad));
                }
                monthToLoad = dayjs(monthToLoad + '-01').add(1, 'month').format('YYYY-MM');
            }
            return Promise.all(promises).then(() => {
                this.firstMonthVisible = month;
            });
        },
    },

    async created() {
        // let month = dayjs(this.dateIn ?? undefined).format('YYYY-MM');

        let month;
        if (!!this.dateIn) {
            month = dayjs(this.dateIn).format('YYYY-MM');
        } else if (this.house.first_availability) {
            month = dayjs(this.house.first_availability).format('YYYY-MM');
        } else {
            month = dayjs().format('YYYY-MM');
        }
        this.firstMonthVisible = this.firstMonthVisible || month;

        for (let i = 0; i <= this.nMonthsVisible; i++) {
            await this.loadDaysForMonth(month)
                .then(() => {
                    month = month
                        ? dayjs(month + '-01').add(1, 'month').format('YYYY-MM')
                        : dayjs(this.myEarliestMonthToShow + '-01').add(1, 'month').format('YYYY-MM')
                    ;
                })
            ;
        }
    },
}
</script>

<style lang="scss">
.date-chooser-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    //justify-content: center;
    align-items: center;

    .date-chooser {
        background-color: white;
        border: 1px solid black;
        border-radius: 15px;
        //padding: 20px;
        padding: 0;
        width: 80vw;
        max-width: 800px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        max-height: 96%;
        //overflow: auto;
        overflow: hidden;

        @media(max-width: 500px) {
            width: 96vw;
            max-height: 96%;
            //padding: 10px;
        }

        & > * {
            flex: 0 0 100%;
            margin: auto;
        }

        .controls {
            text-align: right;
            margin: 10px 0 0 0;
            padding-bottom: 15px;
            border-bottom: 1px solid #777777;

            button {
                margin-left: 20px;
            }
        }

        .month-jump {
            text-align: right;
            margin: 15px auto 5px auto;
            //width: 80vw;
            //max-width: 560px;
            width: 100%;

            label {
                font-weight: bold;
            }
        }

        .month-prev, .month-next {
            text-align: center;

            i {
                display: inline-block;

                &:hover {
                    animation-duration: 0.25s;
                    animation-iteration-count: 2;
                }
            }

        }
        .month-prev i:hover {
            animation-name: indicateUp;
        }

        .month-next i:hover {
            animation-name: indicateDown;
        }

        .hidden {
            visibility: hidden;
        }

        @keyframes indicateUp {
            0% {
                transform: translateY(0);
            }
            50% {
                transform: translateY(-3px);
            }
            100% {
                transform: translateY(0);
            }
        }

        @keyframes indicateDown {
            0% {
                transform: translateY(0);
            }
            50% {
                transform: translateY(3px);
            }
            100% {
                transform: translateY(0);
            }
        }
    }

    section.header {
        padding: 10px;
        background-color: #f2e6c4;

        h3 {
            text-align: center;
            margin: 5px;
        }
    }

    section.months {
        padding: 10px;
        flex: 1 1 100%;
        overflow: auto;
        width: 100%
    }

}
</style>
